<template>
  <div :id="'children_'+uuid"
       :class="{ 'bg-light-primary' : selected, 'bg-light-danger' : !!item.deletedAt || !!item.toBeDelete}"
       class="cursor-pointer border border-1 border-gray-300 rounded d-flex flex-column position-relative w-125px text-center pt-3"
       style="user-select: none; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none;aspect-ratio: 15 / 16"
       @click.prevent.stop="$emit('select', uuid)"
       @contextmenu.prevent.stop="$emit('menu', $event, uuid)">
    <div v-if="item.coverage?.insurer?.photo"
         class="position-absolute bg-white rounded-circle shadow-sm border border-gray-200 d-flex align-items-center justify-content-center overflow-hidden"
         style="top:-8px;right:-8px;width:34px;height:34px;z-index:1"
         :title="item.coverage.insurer.label">
      <img :key="'coverage_'+ uuid +'_insurer_'+item.coverage.insurer.slug" :src="uploadRoot+item.coverage?.insurer?.photo" alt="" class="w-100 h-100 object-contain p-1">
    </div>

    <div class="mt-1 d-flex align-items-center justify-content-center" style="height:48px">
      <img v-if="photo" :src="photo" alt="" class="rounded-circle object-cover" style="width:48px;height:48px"/>
      <i v-else :class="(itemTypes[item.modelCode]?.icon || 'fad fa-cube')+' fs-2x'"></i>
    </div>
    <div>
      <div class="text-muted fs-9 text-uppercase mt-1" style="letter-spacing:0.5px">
        {{ itemTypes[item.modelCode]?.name || item.modelCode }}
      </div>
      <div class="fw-bolder fs-7 mt-1">
        {{ item.alias }}
      </div>
      <div class="text-muted fs-8" v-if="item.identifier && item.identifier !== item.alias">
        {{ item.identifier }}
      </div>
    </div>
    <div :class="{
      'badge-secondary' : item.coverage?.status === 'PENDING',
      'badge-light-danger' : item.coverage?.status === 'EXPIRED',
      'badge-light-success border-success border' : item.coverage?.status === 'ACTIVE',
      'badge-light-warning border-warning border' : item.coverage && !item.coverage.valid && item.coverage.status !== 'EXPIRED'
    }" class="badge badge-secondary m-2">
      <template v-if="item.coverage">
        {{ item.coverage?.category?.label }}
      </template>
      <template v-else>
        NON COUVERT
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({name: 'AssetCard'})
export default class AssetCard extends Vue {
  @Prop({required: true}) item!: any
  @Prop({required: true}) uuid!: string
  @Prop({default: false}) selected!: boolean
  @Prop({required: true}) itemTypes!: Record<string, any>
  @Prop({required: true}) uploadRoot!: string
  @Prop({required: true}) resolvePhoto!: (item: any) => string | null

  get photo(): string | null {
    return this.resolvePhoto(this.item)
  }
}
</script>
